import { Admin, CustomRoutes, Resource } from 'react-admin';
import { useNavigate, useLocation, Route } from 'react-router-dom';
import { Theme } from 'src/Theme';
import LoginPage from 'src/components/LoginPage';
import { CustomLayout } from 'src/components/Layout';
import authProvider, { getAuthFromLocalStorage } from 'src/auth/authProvider';
import i18nProvider from 'src/i18n';
import dataProvider from 'src/api';
import Loader from 'src/components/common/Loader';

import { Resource as ResourceName } from './constants';
import Children from './components/Children';
import Employees from './components/Employees';
import Laws from './components/Laws';
import NotFound from './components/common/Errors/NotFound';
import EducationalCenters from './components/EducationalCenters';
import Subjects from './components/Subjects';
import SpecialServices from './components/SpecialServices';
import Schedule from './components/Schedule';
import Reports from './components/Reports';
import { LandingPage } from './components/common/LandingPage';
import Restricted from './components/common/Errors/Restricted';
import Profile from './components/Profile';

function App() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    if (!getAuthFromLocalStorage() && !pathname.startsWith('/login')) {
        setTimeout(() => navigate('/login'), 50);
        return <Loader />;
    }

    return (
        <Admin
            theme={Theme}
            authProvider={authProvider}
            dataProvider={dataProvider}
            i18nProvider={i18nProvider}
            loginPage={<LoginPage />}
            catchAll={NotFound}
            layout={CustomLayout}
            dashboard={LandingPage}
            disableTelemetry>
            {/*TODO add resources here*/}
            <Resource name={ResourceName.CENTERS} {...EducationalCenters} />
            <Resource name={ResourceName.CHILDREN} {...Children} />
            <Resource name={ResourceName.EMPLOYEES} {...Employees} />
            <Resource name={ResourceName.SCHEDULE} {...Schedule} />
            <Resource name={ResourceName.LAWS} {...Laws} />
            <Resource name={ResourceName.SUBJECTS} {...Subjects} />
            <Resource name={ResourceName.SPECIAL_SERVICES} {...SpecialServices} />
            <Resource name={ResourceName.REPORTS} {...Reports} />
            <Resource name={ResourceName.PROFILE} {...Profile} />
            <CustomRoutes noLayout>
                <Route path="/restricted" element={<Restricted />} />
            </CustomRoutes>
        </Admin>
    );
}

export default App;
